export default [
  {
    path: '/pages/yun/device/batchApp',
    name: 'batchApp',
    meta: { title: '批量操作应用', isLogin: true },
    component: () => import('../pages/yun/device/batchApp.vue')
  },
  {
    path: '/pages/yun/device/batchAppSelect',
    name: 'batchAppSelect',
    meta: { title: '选择应用', isLogin: true },
    component: () => import('../pages/yun/device/batchAppSelect.vue')
  },
  {
    path: '/pages/yun/yun',
    name: 'yun',
    meta: {
      title: "云手机",
      keepAlive: true
    },
    component: () => import('../pages/yun/yun.vue')
  },
  {
    path: '/pages/yun/yunUser',
    name: 'yunUser',
    meta: {
      title: "个人中心"
    },
    component: () => import('../pages/yun/yunUser.vue')
  },

  {
    path: '/pages/yun/groupManage/groupManage',
    name: 'groupManage',
    meta: {
      title: "分组管理"
    },
    component: () => import('../pages/yun/groupManage/groupManage.vue')
  },
  // 
  {
    path: '/pages/yun/groupManage/groupDetail/groupDetail',
    name: 'groupDetail',
    meta: {
      title: "分组详情"
    },
    component: () => import('../pages/yun/groupManage/groupDetail/groupDetail.vue')
  },
  //
  {
    path: '/pages/yun/changeGroup/changeGroup',
    name: 'changeGroup',
    meta: {
      title: "修改分组"
    },
    component: () => import('../pages/yun/changeGroup/changeGroup.vue')
  },
  {
    path: '/pages/yun/groupManage/addDevice/addDevice',
    name: 'addDevice',
    meta: {
      title: "修改分组"
    },
    component: () => import('../pages/yun/groupManage/addDevice/addDevice.vue')
  },
  // 
  {
    path: '/pages/yun/setYunPhone/setYunPhone',
    name: 'setYunPhone',
    meta: {
      title: "设置云手机"
    },
    component: () => import('../pages/yun/setYunPhone/setYunPhone.vue')
  },
  {
    path: '/pages/yun/device/exchange',
    name: 'exchange',
    meta: {
      title: "云手机兑换"
    },
    component: () => import('../pages/yun/device/exchange.vue')
  },
  {
    path: '/pages/yun/device/exchangeRecord',
    name: 'exchangeRecord',
    meta: {
      title: "兑换记录"
    },
    component: () => import('../pages/yun/device/exchangeRecord.vue')
  },
  {
    path: '/pages/yun/device/alldevice',
    name: 'alldevice',
    meta: {
      title: "批量操作"
    },
    component: () => import('../pages/yun/device/alldevice.vue')
  },
  {
    path: '/pages/yun/device/usehelp',
    name: 'usehelp',
    meta: {
      title: "使用帮助"
    },
    component: () => import('../pages/yun/device/usehelp.vue')
  },
  {
    path: '/pages/yun/device/buy',
    name: 'buy',
    meta: {
      title: "购买云手机"
    },
    component: () => import('../pages/yun/device/buy.vue')
  },
  {
    path: '/pages/yun/device/chooseRenew',
    name: 'chooseRenew',
    meta: {
      title: "云手机续费"
    },
    component: () => import('../pages/yun/device/chooseRenew.vue')
  },
  {
    path: '/pages/yun/device/renew',
    name: 'renew',
    meta: {
      title: "云手机续费页"
    },
    component: () => import('../pages/yun/device/renew.vue')
  },
  {
    path: '/pages/yun/device/onedevice',
    name: 'onedevice',
    meta: {
      title: "单设备操控"
    },
    component: () => import('../pages/yun/device/onedevice.vue')
  },
  {
    path: '/pages/yun/device/authorize',
    name: 'yunDeviceAuthorize',
    meta: {
      title: '设备授权',
      isLogin: true
    },
    component: () => import('../pages/yun/device/authorize.vue')
  },
  {
    path: '/pages/yun/device/selectAuthorizeDevice',
    name: 'selectAuthorizeDevice',
    meta: {
      title: '选择云手机',
      isLogin: true
    },
    component: () => import('../pages/yun/device/selectAuthorizeDevice.vue')
  },
  {
    path: '/pages/yun/device/security-password',
    name: 'yunSecurityPassword',
    meta: {
      title: '安全密码',
      isLogin: true
    },
    component: () => import('../pages/yun/device/security-password.vue')
  },
  {
    path: '/pages/yun/device/yun-iframe',
    name: 'yunIframe',
    meta: { title: '云手机' },
    component: () => import('../pages/yun/device/yun-iframe.vue')
  },
  {
    path: '/pages/yun/groupControl/main',
    name: 'groupControl',
    meta: { title: '群控功能' },
    component: () => import('../pages/yun/groupControl/main.vue')
  },
  {
    path: '/pages/yun/device/change-device',
    name: 'changeDevice',
    meta: {
      title: "更换设备"
    },
    component: () => import('../pages/yun/device/change-device.vue')
  },
  {
    path: '/pages/yun/device/exchangeSus',
    name: '/exchangeSus',
    meta: {
      title: "兑换成功"
    },
    component: () => import('../pages/yun/device/exchangeSus.vue')
  },
  {
    path: '/pages/yun/device/deviceCache',
    name: '/deviceCache',
    meta: {
      title: "清理缓存"
    },
    component: () => import('../pages/yun/device/deviceCache.vue')
  },

]
